/**
 * @namespace
 */
 __gh__webApp.ads.teads = {
	 
	 
	 "isInReadDisabled": function(){
		var commonJS						= __gh__webApp.common
			isInReadEnabled 		= commonJS.getObjectProperty(__gh__coreData["3rdPartyData"], "ads.dfp.isInReadDisabled");
	
		return (isInReadEnabled);
	},
	
	/* Inject the Tead InRead Ad Unit
	 * Article must be over the minimum number of characters
	 * Calculates middle paragraph and inserts player right after
	 * If article doesn't have enough characters, place at bottom of article
	 * @param {string} articleDOM - dom of the article
	 */
	 
	"injectInRead": function(articleDOM){

		if (this.isInReadDisabled()) {return;}
		
		var $article 			= $(articleDOM),
			$articleBody		= $article.find(".article-body"),
			minChars			= 2000,
			playerHTML			= '<div class="articleinject adInRead" data-gh-lazy-ad-bucket-targeting=\'{"ad-type":"Rich Media","slot":"articleinject","sov":"base ROS","outofpage":"articleinject","creative-format":"Outstream Video"}\'></div>';
			relatedContentCount = __gh__coreData.globalVariables.article.loadArticle.relatedContentCount;
            
            
            
		//Strip html tags and check total characters
		var regex 		= /(<([^>]+)>)/ig,
			body 		= $articleBody.html(),
			body		= body.replace(regex, ""),
			totalChars 	= body.length;
	
	
		//Inject player at the end of the article
		if(relatedContentCount > 1 || (totalChars < minChars)) {
			$articleBody.append(playerHTML); 
			debug.log("end article")
			return;
		}
	
		
		// Inject Player in the middle of article
		var $articleGraphs = $articleBody.find("p").not(".related p"),
			injectionPoint	= Math.floor($articleGraphs.length / 2);
			debug.log("mid article")
			debug.log("injectionPoint= "+injectionPoint)
			
		$articleGraphs.eq(injectionPoint).after(playerHTML);
		
	},
	
	"loadInRead": function(){
		if(this.isInReadDisabled()){return;}
		try{
			debug.log("define callback object")
			if(typeof(__gh__coreData["3rdPartyData"].paywall.pressplus.ids) !== 'undefined'&&!__gh__coreData["3rdPartyData"].paywall.pressplus.disabled&&!__gh__webApp.paywall.isUserLoggedIn()){
					var callback='pressplus';
			}
			
			var callbackObject = {
				"callback":function(data){
					__gh__webApp.ads.dfp.createLazySlot(data);
				},
				"data": ".articleinject"
			};
			
			if(callback=='pressplus'){
				try{
					debug.info("[inRead DFP Slot] DISPLAY: pressPlusLightboxNotOpen bind");
				    jQuery(window).bind("pressPlusLightboxNotOpen", function (e) {
	
							
						__gh__webApp.ads.dfp.callFunction(callbackObject);
					      debug.info("[inRead DFP Slot] DISPLAY: Press+ site article page.");
		
					});
				}
				catch(e){
					debug.info('Error inRead bound to pressPlusLightboxNotOpen(). '+e)
				}
			}
			else{
					
				__gh__webApp.ads.dfp.callFunction(callbackObject);
				debug.info("[inRead DFP Slot] DISPLAY: NOT Press+ site article page.");
			}
		}
		catch(e){
			debug.info('Error loading inRead. '+e)
		}
	
		
	}
};